import type { FaireProductEntity } from "../../entity_types/product";

export const p_erskkbmy: FaireProductEntity = {
  token: "p_erskkbmy",
  type: "product",
  name: "ShoreBags Classic Tote Medium Private Label Customizable",
  brandToken: "b_7uhhtfna",
  brandName: "ShoreBags",
  imageUrl: "https://cdn.faire.com/fastly/04d6ccd03617014ddfb062d72a43fd8df6784d7f36b0074748ad8c6ba9b1dfe2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cd8179e59915befa22c7564b6c4ce5e87817ca2231ca469894740acfd76dff09.jpeg",
    "https://cdn.faire.com/fastly/057e99173f9c76831a12609d4bc71f495bfbbdde9f53b5d3e47d80622ab7eee3.jpeg",
    "https://cdn.faire.com/fastly/61ec5b6717017f106e98084f7c6aca3b5eb62f6c298b614e18ee281baacd57f2.jpeg",
    "https://cdn.faire.com/fastly/b97d001e1679251cbd587e9f1737b7f8a5c873a4533b533fe45bce14b8851c01.jpeg",
    "https://cdn.faire.com/fastly/0ca1d9b69f661be6e1cf5eff6c2328398249bb2247513fec0692001f218f2239.jpeg",
    "https://cdn.faire.com/fastly/6cba7045057132daa25c09ad6d840b0ceb0363b117a2fd875dd1011e2e6e346f.jpeg",
    "https://cdn.faire.com/fastly/c569d2747da7ca3932e21ed94d1345aec2060f36d7be957c1cd1699028f36c14.jpeg",
    "https://cdn.faire.com/fastly/380189b91998f010894e31d5c4d66d6644cfd999e89b845782757ed87feed8b9.jpeg",
    "https://cdn.faire.com/fastly/e7fadf0444f21cefe278a60c29a6ad3bfa0a756e6b262e6fb906f5d1009a76b1.jpeg",
    "https://cdn.faire.com/fastly/c3d771412950304737ddd891dbc58b62d875bbc248a4c17747d26652ba11e39d.jpeg",
    "https://cdn.faire.com/fastly/73389ae45d4925a9b4423a53fdfa6af1c41b92e8dc0ba6b544e70eee3958d1c4.jpeg",
    "https://cdn.faire.com/fastly/18d07692b49140eb26ad176c0bf45bad40084286a39680c1db61a79935235564.jpeg",
    "https://cdn.faire.com/fastly/0cd3f30ad646cc7de336d5b32f8aea26dab8c94f31fb5b6d132787990f05e021.jpeg",
    "https://cdn.faire.com/fastly/39f95b7c485ed787472b0f3e69b326702448090876f58ccb2ead449905eea0bd.jpeg",
    "https://cdn.faire.com/fastly/73e804e451369bc9ae5a55b23471b75f8a44a232be76424aceb9307a9c1ae96f.jpeg",
    "https://cdn.faire.com/fastly/957fb0dee49cfd121c2b20a6e7976f905a181df7a901dfcc3819c1a6417d23da.jpeg",
    "https://cdn.faire.com/fastly/32c53376e92adc3aed4364a45a260031f31bc66518ddf425eaee544eac8a98f3.jpeg",
    "https://cdn.faire.com/fastly/a2e216130c5f44336e9033422309d98a1a296db0c487b1d194dbe0e9bc92f10a.jpeg",
    "https://cdn.faire.com/fastly/b99367bbcc102eaebdbe90670ab95679ef8534da72ad110bdadc695e23d733f4.jpeg",
    "https://cdn.faire.com/fastly/9961c4c25294d1a7cd2a29baf9d3938d7f10122b81b48cc1295ab2c11527b04d.jpeg",
    "https://cdn.faire.com/fastly/311fd884a488239485f9b301c57eda390ed49ec9bda5af93e4526d1ff6e8142a.jpeg"
  ],
  priceDollars: 30,
  description: "Our ShoreBags classic totes will be your go-to for running errands, airplane carry-ons, packing the kids for a sleepover, or just about anything else. Our durable natural canvas made from sustainable raw materials makes them sturdy and strong enough for the heaviest loads. Fully lined with pockets to organize your things. Choose from 15 colors to suit your style.\n\n• Heavyweight natural cotton canvas\n• Double reinforced straps and bottom\n• 360-degree interior pockets to keep items organized\n• Outside slip pocket for easy access to your keys or phone\n• Handle drop 10\"\n\nWorks great for the beach, weddings, corporate gifting, Mother's Day and Father's Day, graduation, and game days!",
  tags: [],
  msrpDollars: 60,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T18:43:24.030Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
